"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelBackorderDemandHandler = cancelBackorderDemandHandler;
var _types = require("../types");
var _utils = require("../utils");
async function cancelBackorderDemandHandler({
  detail: {
    lineNumber,
    placement
  }
}) {
  const response = await fetch(`${_types.RequestUrl.CancelBackorderDemand}?lineNumber=${lineNumber}`, (0, _utils.getHttpRequestSettings)({
    placement
  }));
  return (0, _utils.convertToCamelCase)(await response.json());
}
